import type { SightmapComponent } from './schema.ts'

/** The page is the durable outermost component, including on maps with no named regions.
 * Shared by QA target resolution and Subtext export; never derived from a recording node ID. */
export const PAGE_ROOT_COMPONENT: SightmapComponent & { id: string } = {
  id: 'qa-page-root', name: 'Page content', selector: 'body', kind: 'component',
}
